export default {
  loading: false,
  supervisor_invoices: [],
  supervisor_invoice: {},
  totalCount: 0,
};
